import React from "react";
import "./Footer.css";
// import NintendoStore from "./imaged/playstation-store.jpg";

// import img from "./image 1 copy.jpg";
import gamefilter from "../../dataset/gamefilter.json";
import { articlesData } from "../../Views/Articles/articlesData";

import { useTranslation } from 'react-i18next';

function Footer(props) {
  const { t } = useTranslation(); // ดึงฟังก์ชันแปลจาก useTranslation
  const filters = gamefilter

  return (
    <div >
      <section style={{ height: "20px" }}></section>
      <div className="text-center">
        <img

          src={require("../../assets/banks.png")}
          alt="RN69"
          width={320}
        />
      </div>

      <div className="container">
        <footer className="footer-bs">

          <div className="row">
            <div className="col-md-3 footer-brand animated fadeInLeft">
              <img
                src={require("../../assets/RN69.png")}
                alt="RN69"
                width={80}
              />
              {/* <p>Suspendisse hendrerit tellus laoreet luctus pharetra. Aliquam porttitor vitae orci nec ultricies. Curabitur vehicula, libero eget faucibus faucibus, purus erat eleifend enim, porta pellentesque ex mi ut sem.</p> */}
              <p>© 2025 RN69, All rights reserved</p>
            </div>
            {/* <div className="col-md-4 footer-nav animated fadeInUp">
              <h4>{t('menu')} —</h4>
              <div className="col-md-6">
                <ul className="pages">
                  {filters.map((filter, index) => (
                    <li><a href={filter.path}>{t(filter.category)}</a></li>
                  ))}
         
                </ul>
              </div>
              <div className="col-md-6">
              <ul className="list">
                <li><a href="#">About Us</a></li>
                <li><a href="#">Contacts</a></li>
                <li><a href="#">Terms & Condition</a></li>
                <li><a href="#">Privacy Policy</a></li>
              </ul>
            </div>
            </div> */}
            {/* <div className="col-md-5 footer-social animated fadeInDown">
              <h4>{t('articles')} —</h4>
              <ul>
                {articlesData.map((article, index) => (
                  <li><a href={`/article/id/${article.id}`}>{t(article.title)}</a></li>
                ))}
         
              </ul>
            </div> */}
            {/* <div className="col-md-3 footer-ns animated fadeInRight">
            <h4>Newsletter</h4>
            <p>A rover wearing a fuzzy suit doesn’t alarm the real penguins</p>
            <p>
              <div className="input-group">
                <span className="input-group-btn">
                  <button className="btn btn-default" type="button"><span className="glyphicon glyphicon-envelope"></span></button>
                </span>
              </div>
            </p>
          </div> */}
          </div>
        </footer>
        {/* <section style={{ textAlign: "center", margin: "10px auto" }}><p>Designed by <a href="http://princesargbah.me">Prince J. Sargbah</a></p></section> */}
        <section style={{ height: "50px" }}></section>
      </div>

    </div>

  );
}

export default Footer;
